module.exports = __webpack_public_path__ + "static/media/preparing.ed564859.svg";